import { createFileRoute } from "@tanstack/react-router";

import { WhatsComingPage } from "~/components/feature-votes/whats-coming-page";
import { myFeatureVotesQueryOptions } from "~/lib/functions/feature-votes";
import { plannedFeatureVoteItems } from "~/lib/shared/feature-votes/items";

export const Route = createFileRoute("/_user/my-coaching/whats-coming")({
  staticData: { title: "What's coming" },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(myFeatureVotesQueryOptions);
    return {};
  },
  component: () => <WhatsComingPage items={plannedFeatureVoteItems()} />,
});
